/** In-memory JWT set on login so API calls work before redux-persist flushes. */
let memoryAccessToken: string | null = null;

export const setMemoryAccessToken = (token: string | null): void => {
  memoryAccessToken = token;
};

export const getAccessToken = (): string | null => {
  if (memoryAccessToken) {
    return memoryAccessToken;
  }

  try {
    const persistedState = localStorage.getItem('persist:auth');
    if (!persistedState) {
      return null;
    }
    const parsed = JSON.parse(persistedState) as { token?: string };
    const raw = parsed.token;
    if (!raw || raw === 'null') {
      return null;
    }
    try {
      const decoded = JSON.parse(raw) as unknown;
      return typeof decoded === 'string' ? decoded : null;
    } catch {
      return raw.startsWith('eyJ') ? raw : null;
    }
  } catch {
    return null;
  }
};
